import {FuseNavigation} from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id: 'main_group',
        title: '',
        translate: '',
        type: 'group',
        hidden: true,
        children: [
            {
                id: 'clients',
                title: 'Klienti',
                translate: 'NAV.CLIENTS',
                type: 'item',
                icon: 'group',
                url: '/client-list',
            },
            {
                id: 'client-pre-analyza',
                title: 'Předanalýza',
                translate: 'NAV.PRE_ANALYSIS_CLIENT',
                type: 'item',
                icon: 'group',
                url: '/client-pred-analyza',
            },
            {
                id: 'client-new',
                title: 'Nový klient',
                translate: 'NAV.NEW_CLIENT',
                type: 'item',
                icon: 'person_add',
                url: '/client-new',
                hidden: true,
            },
            {
                id: 'client-import',
                title: 'Importovat klienta',
                translate: 'NAV.IMPORT_CLIENT',
                type: 'item',
                icon: 'person_add',
                url: '/client-import',
                hidden: true,
            },
            {
                id: 'invest-group',
                title: 'Investiční garant',
                type: 'group',
                hidden: true,
                children: [
                    {
                        id: 'investment-garant-waiting',
                        title: 'Čekající',
                        translate: 'NAV.INVESTMENT_GARANT_WAITING',
                        type: 'item',
                        icon: 'watch_later',
                        url: '/investicni-garant/cekajici',
                    },
                    {
                        id: 'investment-garant-approved',
                        title: 'Hotové',
                        translate: 'NAV.INVESTMENT_GARANT_DONE',
                        type: 'item',
                        icon: 'done_all',
                        url: '/investicni-garant/hotove',
                    },
                    {
                        id: 'investment-garant-cancelled',
                        title: 'Automatické',
                        translate: 'NAV.INVESTMENT_GARANT_AUTOMATIC',
                        type: 'item',
                        icon: 'android',
                        url: '/investicni-garant/automaticke',
                    },
                ]
            },
            {
                id: 'client-links',
                title: 'Klient',
                translate: 'NAV.CLIENT',
                hidden: true,
                type: 'group',
                children: [
                    {
                        id: 'client-detail',
                        title: 'Další osobní informace',
                        type: 'item',
                        icon: 'assignment_ind',
                        url: '/client-detail'
                    },
                    {
                        id: 'client-financni-analyza',
                        title: 'Finanční analýza',
                        type: 'item',
                        icon: 'equalizer',
                        url: '/financni-analyza'
                    },
                    // {
                    //     id: 'client-financial-balance',
                    //     title: 'Finanční bilance',
                    //     type: 'item',
                    //     icon: 'equalizer',
                    //     url: '/client-financial-balance'
                    // },
                    // {
                    //     id: 'client-financial-balance-v2',
                    //     title: 'Finanční bilance V2',
                    //     type: 'item',
                    //     icon: 'equalizer',
                    //     url: '/financni-bilance-v2'
                    // },
                    {
                        id: 'client-state-and-goals',
                        title: 'Cíle a přání klienta',
                        type: 'item',
                        icon: 'near_me',
                        url: '/client-state-and-goals'
                    },
                    {
                        id: 'client-documents',
                        title: 'Dokumenty',
                        type: 'item',
                        icon: 'collections_bookmark',
                        url: '/client-documents'
                    },
                    {
                        id: 'client-portal',
                        title: 'Portál',
                        type: 'item',
                        icon: 'smartphone',
                        url: '/client-portal'
                    },
                    {
                        id: 'client-financial-plan',
                        title: 'Finanční plán',
                        type: 'item',
                        icon: 'attach_money',
                        url: '/client-financial-plan'
                    },
                    {
                        id: 'client-tools',
                        title: 'Nástroje',
                        type: 'item',
                        icon: 'build',
                        url: '/client-tools'
                    },
                    {
                        id: 'service-introduction',
                        title: 'Představení služby',
                        type: 'item',
                        icon: 'equalizer',
                        url: '/service-introduction'
                    },
                ],
            },
            {
                id: 'devgroup',
                title: 'DEV',
                type: 'group',
                children: [
                    {
                        id: 'devform',
                        title: 'DEV form',
                        type: 'item',
                        icon: 'bug_report',
                        url: '/dev-form'
                    },
                    {
                        id: 'demo',
                        title: 'DEMO',
                        type: 'item',
                        icon: 'bug_report',
                        url: '/demo'
                    },
                ],
            },
        ],
    }
];
